/*
 * Public API Surface of global-menu
 */

export * from './lib/global-menu.service';
export * from './lib/global-menu/global-menu.component';
export * from './lib/main-menu/main-menu.component';
export * from './lib/global-menu.module';
